module.exports = __webpack_public_path__ + "assets/img/news-2.dccdadd5.jpg";